export default "__VITE_ASSET__DxzZhr9Y__"